import React from 'react';

var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });
const IcMagnet = /* @__PURE__ */ __name((properties) => /* @__PURE__ */ React.createElement("svg", {
  fill: "none",
  height: "24",
  width: "24",
  xmlns: "http://www.w3.org/2000/svg",
  ...properties
}, /* @__PURE__ */ React.createElement("path", {
  d: "M3.5 16h5v3a1 1 0 0 1-1 1h-3a1 1 0 0 1-1-1v-3Zm12 0h5v3a1 1 0 0 1-1 1h-3a1 1 0 0 1-1-1v-3Z",
  fill: "var(--mds-nav-icon-medium)"
}), /* @__PURE__ */ React.createElement("path", {
  clipRule: "evenodd",
  d: "M12 8a3.5 3.5 0 0 0-3.5 3.5V14h-5v-2.5a8.5 8.5 0 0 1 17 0V14h-5v-2.5A3.5 3.5 0 0 0 12 8Z",
  fill: "var(--mds-nav-icon-accent)",
  fillRule: "evenodd"
})), "IcMagnet");

export { IcMagnet };
//# sourceMappingURL=ic-magnet.js.map
